<template>
  <form v-if="form" class="space-y-6 w-full pb-3">

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

      <template v-if="item.additional_details">
        <template v-for="(detail, index) in item.additional_details" :key="index">
          <div class="col-span-1">
            <Input v-model="form.additional_details[index].value" :errors="errors.detail" :placeholder="detail.name" type="number" />
          </div>
        </template>
      </template>

    </div>

    <div class="">
      <div class="flex justify-end">
        <button type="button" class="bg-white dark:bg-gray-750 py-2 px-4 border border-gray-300 dark:border-gray-500 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-770 focus:outline-none focus:ring-0 mr-2"
                @click="close">
          Atcelt
        </button>

        <template v-if="!loading">
          <button type="button" class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gradient-to-r from-button2-from to-button2-to hover:from-button2-to hover:to-button2-from focus:outline-none focus:border-none transition duration-500 ease-in-out"
                  @click.prevent="submit">
            Saglabāt
          </button>
        </template>
        <template v-else>
          <Loading />
        </template>
      </div>
    </div>

  </form>
</template>

<script>
import { mapGetters } from "vuex";
import Input from "@/components/Components/Input";
import Loading from "@/components/Components/Loading";

export default {
  name: "EditProcurementAdditionalDetails",
  components: {
    Input,
    Loading,
  },
  props: ["item"],
  data: () => ({
    form: null
  }),
  computed: {
    ...mapGetters({
      loading: "loading",
      errors: "errors",
    }),
  },
  created() {
    this.form = this.item
  },
  methods: {
    close() {
      this.$emit('close-dialog')
      this.$store.dispatch("removeAllFormsForDisplay");
      this.$store.dispatch("setErrors", {});
      this.$store.dispatch("getSingleProcurement", this.item.id);
    },
    submit() {
      this.$Progress.start();
      this.$store.dispatch("updateProcurementAdditionalDetails", {
        id: this.form.id,
        data: {
          additional_details: this.form.additional_details
        }
      })
      .then(response => {
        this.$store.dispatch("removeAllFormsForDisplay");
      })
    },
  },
}
</script>